import React from 'react';
import './Footer.css';
import { useLanguage } from '../LanguageContext';
import logoIcon from '../assets/images/header-logo.png';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={logoIcon} alt="Float Logo" className="logo-icon" />
          <span className="logo-text">Float</span>
        </div>
        
        <div className="footer-info">
          <p className="partnership">
            {t('footerPartnership')} <a href="mailto:support@float.app" className="email-link">support@float.app</a>
          </p>
        </div>
        
        <div className="social-media">
          <span className="social-label">{t('footerSocial')}</span>
          <div className="social-icons">
            <a href="#" className="social-icon instagram" aria-label="Instagram">
              <span>📷</span>
            </a>
            <a href="#" className="social-icon facebook" aria-label="Facebook">
              <span>f</span>
            </a>
            <a href="#" className="social-icon linkedin" aria-label="LinkedIn">
              <span>in</span>
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p className="copyright">{t('footerCopyright')}</p>
      </div>
    </footer>
  );
};

export default Footer;
